import { Outlet, createFileRoute } from '@tanstack/react-router'

import { Sidebar } from '@/components/shared/layout/sidebar'
import { PrivacyOverlay } from '@/components/shared/layout/privacy-overlay'
import { SidebarProvider } from '@/components/shared/loading-logo'

export const Route = createFileRoute('/_auth/_main-layout')({
  component: MainLayout,
})

function MainLayout() {
  return (
    <SidebarProvider>
      <div className="flex h-screen overflow-hidden">
        <Sidebar />
        <main className="relative flex-1 overflow-y-auto h-screen">
          <Outlet />
          <PrivacyOverlay />
        </main>
      </div>
    </SidebarProvider>
  )
}
